let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3u9UD")).then(() => parcelRequire('kGPp7'));